// extracted by mini-css-extract-plugin
module.exports = {"emptyBlock":"EmptyView_emptyBlock__xGDdZ","empty":"EmptyView_empty__a-gDB","black":"EmptyView_black__1W7_k"};